import React from 'react';
import classnames from 'classnames';
import styles from './Spinner.module.scss';

export interface SpinnerProps {
  // Spinner size
  size: 'small' | 'normal' | 'large';

  // Additional styles can come with className
  className?: string;
  spinnerClassName?: string;

  // Margin of the spinner container
  gapSize?: 'small' | 'normal' | 'large';
}

const Spinner: React.FC<SpinnerProps> = ({
  className,
  size = 'small',
  gapSize,
  spinnerClassName
}) => {
  const spinnerClassNames = classnames(
    styles.spinner,
    {
      [styles.small]: size === 'small',
      [styles.normal]: size === 'normal',
      [styles.large]: size === 'large'
    },
    spinnerClassName
  );

  const containerClassName = classnames(
    className,
    gapSize && {
      [styles.gapSmall]: gapSize === 'small',
      [styles.gapNormal]: gapSize === 'normal',
      [styles.gapLarge]: gapSize === 'large'
    }
  );

  return (
    <div data-testid={'spinner'} className={containerClassName}>
      <span className={spinnerClassNames} />
    </div>
  );
};

export default Spinner;
